export default "/images/physical_activity_environment_sm.jpg?f5dfa4a4d3ed64461b8bf95bc1732b62";